<template>
  <div class="container">
    <account-tab-menu />
    <div class="row align-items-center mt-5">
      <div class="col">
        <div class="mb-5">
          <h2>ประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Notice)</h2>
        </div>
        <div class="mb-3">
          <b>บริษัท สยามสแควร์ เทคโนโลยี (ประเทศไทย) จำกัด และบริษัทในเครือ</b>
          (ซึ่งต่อไปในประกาศนี้ เรียกว่า <b>“S2”</b> หรือ <b>“เรา”</b> หรือ
          <b>“บริษัทฯ”</b> หรือ <b>“องค์กร”</b>)
          ถือปฏิบัติอย่างเคร่งครัดและตระหนักถึงความสำคัญในสิทธิความเป็นส่วนตัวของท่าน
          (เรียกรวมกันว่า <b>“ท่าน”</b> หรือ <b>“เจ้าของข้อมูล”</b>)
          เมื่อเราใช้ข้อมูลส่วนบุคคลของท่านในการดำเนินธุรกิจและให้บริการกับท่าน
          ฉะนั้น
          ข้อมูลส่วนบุคคลของท่านจะได้รับการคุ้มครองตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
          พ.ศ. 2562<br />
          เราในฐานะผู้คุ้มครองข้อมูลส่วนบุคคลของท่าน
          มีหน้าที่ปฏิบัติตามกฎหมายอย่างเคร่งครัดเพื่อแจ้งให้ท่านทราบถึงนโยบายความเป็นส่วนตัวของเจ้าของข้อมูลส่วนบุคคล
          ซึ่งอธิบายถึงการเก็บ รวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
          ตลอดจนสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล ทั้งนี้
          เราขอยืนยันว่าได้ปฏิบัติตามกฎหมายฉบับนี้เพื่อคุ้มครองข้อมูลส่วนบุคคลของท่านอย่างเคร่งครัดแล้ว
        </div>
        <div class="mb-3">
          <b>ความหมายของข้อมูลส่วนบุคคล</b><br />
          ข้อมูลส่วนบุคคลแบ่งออกเป็นสองประเภท ได้แก่<br />
          <b>ข้อมูลส่วนบุคคล (ทั่วไป)</b><br />หมายถึง
          ข้อมูลส่วนบุคคลของคนที่มีชีวิตอยู่ที่สามารถระบุตัวตนของบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม
          เช่น ชื่อ นามสกุล ที่อยู่ Email address หมายเลขบัตรประจำตัวประชาชน<br />

          <b>ข้อมูลส่วนบุคคลที่อ่อนไหว (Sensitive Personal Data)</b
          ><br />หมายถึง ข้อมูลส่วนบุคคลที่ต้องได้รับการคุ้มครองเป็นพิเศษ
          ซึ่งจำเป็นต้องให้ความระมัดระวังเป็นพิเศษในการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลประเภทนี้ เช่น
          ข้อมูลส่วนบุคคลเกี่ยวกับเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง
          ความเชื่อในลัทธิ ศาสนาหรือปรัชญาพฤติกรรมทางเพศ ประวัติอาชญากรรม
          ข้อมูลสุขภาพ ความพิการ ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม
          และข้อมูลชีวภาพ
        </div>

        <div class="mb-3">
          <b
            >1. วัตถุประสงค์ในการเก็บรวบรวม ประมวลผลข้อมูลส่วนบุคคล
            และการนำไปใช้</b
          ><br />บริษัทฯ
          อาจนำข้อมูลส่วนบุคคลไปใช้ตามวัตถุประสงค์ดังต่อไปนี้หรือตามวัตถุประสงค์อื่น
          ๆ ที่แจ้ง
          ขณะเก็บรวบรวมข้อมูลหรือที่ท่านได้ให้ความยินยอมหลังจากเราดำเนินการเก็บข้อมูลไปแล้ว
          เราดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านภายใต้จุดประสงค์<br />
          ดังต่อไปนี้ <br />1. เพื่อเข้าทำสัญญา
          หรือปฎิบัติหน้าที่ตามสัญญาระหว่างบริษัทฯ กับเจ้าของข้อมูล
          หรือปฎิบัติหน้าที่ตามสัญญาระหว่างบริษัทฯ
          กับบุคคลภายนอกเพื่อประโยชน์ของข้อมูล<br />
          2. ใช้ข้อมูลในการยืนยันตัวตนลูกค้า<br />
          3. เพื่อให้ข้อมูลและแนะนำสินค้า ผลิตภัณฑ์ การบริการ
          หรือประชาสัมพันธ์ทางการตลาดรายการส่งเสริมการขาย
          หรือสิทธิประโยชน์ผ่านช่องทางการติดต่อที่ได้รับจากเจ้าของข้อมูล<br />
          4.
          เพื่อจัดส่งสินค้าและการให้บริการเพื่อตอบสนองความต้องการหรือข้อร้องเรียนต่าง
          ๆ<br />
          5. ใช้ในการดำเนินกิจการ ประเมินผล และปรับปรุงธุรกิจ
          เพื่อพัฒนาคุณภาพสินค้าและบริการ<br />
          6. ดำเนินกิจกรรมใด ๆ ทางบัญชีและการเงิน เช่น การตรวจสอบบัญชี
          การแจ้งและเรียกเก็บหนี้ การออกใบกำกับภาษี
          และหลักฐานการดำเนินธุรกรรมต่าง ๆ ที่กฏหมายกำหนด<br />
          7. เพื่อประโยชน์อันชอบด้วยกฎหมายของบริษัทฯ เช่น
          การบันทึกเสียงการร้องเรียนผ่านระบบ Call Center การบันทึกภาพผ่านกล้อง
          CCTV การบันทึก เข้า-ออก ภายในบริษัทฯ<br />
          8. การปฎิบัติตามกฏของบริษัทฯ<br />
          9. การสมัครงาน การเป็นพนักงาน
          และ/หรือวัตถุประสงค์อื่นใดที่เกี่ยวจ้อง<br />
          10.ใช้ในการสอบสวนและปฎิบัติและปฏิบัติตามกฎหมายข้อบังคับหรือหน้าที่ตามกฎหมายของบริษัท
          <br />
          11.ตอบสนองต่อคำขอของท่าน เช่น
          การให้บริการหลังการขายการรับเรื่องร้องเรียน <br />
          12.อำนวยความสะดวกและนำเสนอรายการสิทธิประโยชน์ต่าง ๆ แก่ผู้ใช้บริการ<br />
          13.จุดประสงค์ด้านการตลาด การส่งเสริมการขายและการลูกค้าสัมพันธ์ เช่น
          การส่งข้อมูลเกี่ยวกับโปรโมชัน ผลิตภัณฑ์และบริการ รายการส่งเสริมการขาย
          และธุรกิจพันธมิตร<br />
          14.สำรวจความพึงพอใจของผู้ใช้บริการ
          วิจัยตลาดและวิเคราะห์ทางสถิติทางสถิติ
          เพื่อเป็นข้อมูลในการปรับปรุงผลิตภัณฑ์และบริการ
          หรือสร้างสรรค์ผลิตภัณฑ์และบริการใหม่ ๆ<br />
          15.วัตถุประสงค์อื่น ๆ ที่ได้รับคำยินยอมชัดแจ้งจากท่าน <br />
        </div>

        <div class="mb-3">
          <b>2. ข้อมูลส่วนบุคคลที่เราเก็บรวบรวม</b><br />
          เราอาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านดังรายการต่อไปนี้
        </div>

        <div class="container">
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div class="text-center">
                <b>ชนิดของข้อมูล</b>
              </div>
            </div>
            <div class="col border border-dark">
              <div class="text-center"><b>รายการข้อมูล</b></div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ข้อมูลส่วนบุคคล</div>
            </div>
            <div class="col border border-dark">
              <div>
                เช่น ชื่อ-นามสกุล, อายุ, วันเกิด, เลขบัตรประจำตัวประชาชน,
                เลขที่หนังสือเดินทาง, สำเนาหนังสือเดินทาง, เลขใบขับขี่,
                ลายมือชื่อ, สำเนาบัตรประชาชน, สำเนาทะเบียนบ้าน, สถานภาพสมรส,
                ตำแหน่ง, อาชีพ, การศึกษา, เลขทะเบียนผู้ถือหุ้น, ประวัติการทำงาน
                เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col-6 border border-dark">
              <div>ข้อมูลสำหรับติดต่อ</div>
            </div>
            <div class="col-6 border border-dark">
              <div>
                เช่น ที่อยู่, หมายเลขโทรศัพท์, อีเมล, นามบัตร, สถานที่ทำงาน
                เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col-6 border border-dark">
              <div>ข้อมูลรูปภาพ</div>
            </div>
            <div class="col-6 border border-dark">
              <div>
                เช่น ข้อมูลภาพนิ่ง,
                ภาพเคลื่อนไหวของตัวท่านหรือทรัพย์สินของท่านซึ่งได้รวบรวมจากกล้องโทรทัศน์วงจรปิด,
                กล้องภาพถ่ายเมื่อมีการเข้าในพื้นที่บริษัทฯ เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col-6 border border-dark">
              <div>ข้อมูลบัญชีผู้ใช้บริการบนแพลตฟอร์ม</div>
            </div>
            <div class="col-6 border border-dark">
              <div>เช่น ชื่อบัญชีผู้ใช้งานแพลตฟอร์ม และ รหัสผ่าน</div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col-6 border border-dark">
              <div>ข้อมูลทางการเงิน</div>
            </div>
            <div class="col-6 border border-dark">
              <div>
                เช่น ข้อมูลบัญชีธนาคาร, สำเนาสมุดบัญชี, เลขบัตรเครดิต,
                ข้อมูลวงเงินเครดิต, ข้อมูลการทำธุรกรรมรวมถึงข้อมูล
                เกี่ยวกับผลิตภัณฑ์และบริการที่ท่านซื้อ ราคา วิธีการชำระเงิน
                และรายละเอียดการชำระเงิน เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col-6 border border-dark">
              <div>ข้อมูลเกี่ยวกับการซื้อสินค้าและบริการ</div>
            </div>
            <div class="col-6 border border-dark">
              <div>
                เช่น ประวัติการสั่งซื้อ, ความสนใจในการซื้อบริการและผลิตภัณฑ์,
                หมายเลขการสั่งซื้อ, หมายเลขคำร้องขอ เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark mb-3">
            <div class="col-6 border border-dark">
              <div>ข้อมูลที่ได้จากระบบอัตโนมัติ หรือ อุปกรณ์ต่าง ๆ</div>
            </div>
            <div class="col-6 border border-dark">
              <div>
                เช่น หมายเลข IP Address, Cookies, พฤติกรรมการใช้บริการ,
                ประวัติการใช้บริการ, เสียง, ภาพถ่าย, ภาพเคลื่อนไหว, ชื่อบัญชี
                Social Media, ชื่อบัญชี App - Chat, Geolocation เป็นต้น
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <b>3. แหล่งที่มาของข้อมูล</b><br />
          บริษัทฯ
          อาจนำข้อมูลส่วนบุคคลไปใช้ตามวัตถุประสงค์ดังต่อไปนี้หรือตามวัตถุประสงค์อื่น
          ๆ ที่แจ้ง
          ขณะเก็บรวบรวมข้อมูลหรือที่ท่านได้ให้ความยินยอมหลังจากเราดำเนินการเก็บข้อมูลไปแล้ว
          เราดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านภายใต้จุดประสงค์
          ดังต่อไปนี้<br />

          1. ข้อมูลจากเจ้าของข้อมูลโดยตรง ที่ท่านได้ให้ไว้ในกิจกรรมต่าง ๆ เช่น
          ช่องทางแอพพลิเคชัน, เว็บไซต์, Facebook Page, Messenger, LINE Official
          Account หรือ ช่องทางอื่น ๆ ของบริษัทฯ, การเข้า-ออก ภายในบริษัท,
          การซื้อสินค้าหรือใช้บริการจากทางบริษัทฯ, การจัดอบรม,
          การจัดซื้อจัดจ้าง, การทำธุรกรรมแบบออนไลน์และออฟไลน์
          หรือการตอบโต้ทางอีเมล หรือการกรอก / ให้ข้อมูลประกอบการสมัครงาน
          หรือช่องทางการสื่อสาร อื่น ๆ ระหว่างบริษัทฯ และท่าน<br />
          2. ข้อมูลจากบุคคลที่สามที่มีความเกี่ยวข้อง เช่น ญาติ, คนในครอบครัว<br />
          3. ข้อมูลจากระบบอัตโนมัติ เช่น ภาพหรือเสียงจากกล้องวงจรปิด <br />
          4. ข้อมูลจากแหล่งอื่น เช่น ข้อมูล สาธารณะ ข้อมูลจากหน่วยงานพันธมิตร
          หน่วยงานราชการ หรือ บริษัทในเครือ ตลอดจนข้อมูลส่วนบุคคลอื่น ๆ
          ที่ผู้ใช้บริการได้มอบไว้ให้
        </div>

        <div class="mb-3">
          <b>4. การเปิดเผยข้อมูลส่วนบุคคลของท่าน</b><br />
          บริษัทจะไม่เปิดเผยและส่งต่อข้อมูลส่วนบุคคลของท่านไปยังหน่วยงานภายนอกเว้นแต่ได้รับคำยินยอมชัดแจ้งจากท่านหรือเป็นไปตามกรณีต่อไปนี้
          <br />

          1.
          เพื่อบรรลุวัตถุประสงค์ตามที่ระบุในนโยบายความเป็นส่วนตัวฉบับนี้บริษัทอาจจำเป็นต้องเปิดเผยหรือแบ่งปันข้อมูลเฉพาะเท่าที่จำเป็นแก่คู่ค้าผู้ให้บริการหรือหน่วยงานภายนอกดังต่อไปนี้
          <br />
          1.1 ธุรกิจคู่ค้าและธุรกิจพันธมิตร <br />
          1.2 ตัวแทนหรือคู่ค้าที่ให้บริการแก่บริษัทหรือดำเนินการใด ๆ
          ในฐานะตัวแทนของบริษัท เช่น
          ผู้ให้บริการขนส่งผู้ให้บริการเก็บและทำลายเอกสาร
          ผู้รับจ้างทำกิจกรรมทางการตลาดและสื่อโฆษณา
          ผู้รับจ้างพัฒนาและดูแลระบบความปลอดภัยและเทคโนโลยีสารสนเทศ
          ผู้ตรวจสอบบัญชี ทนายความ ที่ปรึกษากฎหมายหรือภาษี เป็นต้น <br />
          1.3 หุ้นส่วนทางธุรกิจ <br />
          1.4 ธนาคารและผู้ให้บริการชำระเงิน เช่น บริษัทบัตรเครดิตหรือเดบิต
          เป็นต้น ทั้งนี้
          บริษัทจะจัดทำข้อตกลงการประมวลผลข้อมูลส่วนบุคคลตามที่กฎหมายกำหนด <br />
          2.บริษัทอาจเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคลให้แก่บริษัทในเครือโดยจะเป็นการประมวลผลข้อมูลภายใต้วัตถุประสงค์ที่ระบุในนโยบายความเป็นส่วนตัวฉบับนี้เท่านั้น
          <br />
          3.กฎหมายหรือกระบวนการทางกฎหมายบังคับให้เปิดเผยข้อมูลหรือเปิดเผยต่อเจ้าหน้าเจ้าพนักงานเจ้าหน้าที่รัฐหรือหน่วยงานที่มีอำนาจเพื่อปฏิบัติตามคำสั่งหรือคำขอที่ชอบด้วยกฎหมาย
        </div>

        <div class="mb-3">
          <b
            >5. สิทธิตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
            ของท่าน</b
          ><br />
          พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
          มีวัตถุประสงค์เพื่อให้ข้อมูลส่วนบุคคลของท่านอยู่ในความควบคุมของท่านได้มากขึ้น
          โดยท่านสามารถใช้สิทธิตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
          เมื่อบทบัญญัติในส่วนที่เกี่ยวกับสิทธิของเจ้าของข้อมูลส่วนบุคคลมีผลใช้บังคับ
          ซึ่งมีรายละเอียดดังต่อไปนี้

          <br />

          1. สิทธิในการเข้าถึง รับสำเนา
          และขอให้เปิดเผยที่มาของข้อมูลส่วนบุคคลของท่านที่เราเก็บรวบรวมอยู่
          เว้นแต่กรณีที่เรามีสิทธิปฏิเสธคำขอของท่านตามกฎหมายหรือคำสั่งศาล
          หรือกรณีที่คำขอของท่านจะมีผลกระทบที่อาจก่อให้เกิดความเสียหายต่อสิทธิและเสรีภาพของบุคคลอื่น<br />
          2. สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลของท่านที่ไม่ถูกต้องหรือไม่ครบถ้วน
          เพื่อให้มีความถูกต้อง เป็นปัจจุบัน สมบูรณ์
          และไม่ก่อให้เกิดความเข้าใจผิด<br />
          3.สิทธิในการขอให้ระงับการใช้ข้อมูลส่วนบุคคลของท่านในกรณีหนึ่งกรณีใดดังต่อไปนี้<br />
          3.1
          เมื่ออยู่ในช่วงเวลาที่เราทำการตรวจสอบตามคำร้องขอของท่านให้แก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง
          สมบูรณ์ และเป็นปัจจุบัน<br />
          3.2 ข้อมูลส่วนบุคคลของท่านถูกเก็บรวบรวม
          ใช้หรือเปิดเผยโดยมิชอบด้วยกฎหมาย<br />
          3.3
          เมื่อข้อมูลส่วนบุคคลของท่านหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์เราได้แจ้งไว้ในการเก็บรวบรวม
          แต่ท่านประสงค์ให้เราเก็บรักษาข้อมูลนั้นต่อไปเพื่อประกอบการใช้สิทธิตามกฎหมายของท่าน<br />
          3.4
          เมื่ออยู่ในช่วงเวลาที่เรากำลังพิสูจน์ให้ท่านเห็นถึงเหตุอันชอบด้วยกฎหมายในการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน
          หรือตรวจสอบความจำเป็นในการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อประโยชน์สาธารณะ
          อันเนื่องมาจากการที่ท่านได้ใช้สิทธิคัดค้านการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน<br />
          4. สิทธิในการคัดค้านการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน
          เว้นแต่กรณีที่เรามีเหตุในการปฏิเสธคำขอของท่านโดยชอบด้วยกฎหมาย (เช่น
          เราสามารถแสดงให้เห็นว่าการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่านมีเหตุอันชอบด้วยกฎหมายยิ่งกว่า
          หรือเพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย
          การปฏิบัติตามหรือการใช้สิทธิเรียกร้องทางกฎหมาย
          หรือเพื่อประโยชน์สาธารณะตามภารกิจของเรา)
        </div>

        <div class="mb-3">
          <b>6. การส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ</b><br />
          เราอาจส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ
          โดยเราจะทำให้แน่ใจว่าประเทศปลายทางหรือหน่วยงายปลายทาง
          มีมาตรฐานและนโยบายในการคุ้มครองความเป็นส่วนตัวที่เพียงพอ
          และเราจะดำเนินการตามหลักเกณฑ์การให้ความคุ้มครองข้อมูลส่วนบุคคลที่ส่งหรือโอนไปยังต่างประเทศที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด
          เว้นแต่กรณีดังต่อไปนี้

          <br />

          1.
          เป็นการปฏิบัติตามกฎหมายที่กำหนดให้เราจำเป็นต้องส่งหรือโอนข้อมูลส่วนบุคคลไปต่างประเทศ
          <br />
          2. เราได้แจ้งให้ท่านทราบและได้รับความยินยอมจากท่าน
          ในกรณีที่ประเทศปลายทางมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่ไม่เพียงพอ
          ทั้งนี้เป็นไปตามรายชื่อประเทศที่คณะกรรมการคุ้มครองส่วนบุคคลประกาศกำหนด
          <br />
          3. เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย
          หรือสุขภาพของท่านหรือของบุคคลอื่น
          เมื่อท่านไม่สามารถให้ความยินยอมในขณะนั้นได้ หรือ
          เพื่อดำเนินภารกิจเพื่อประโยชน์สาธารณะที่สำคัญ<br />
        </div>

        <div class="mb-3">
          <b>7. ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล</b><br />
          เราเก็บรักษาข้อมูลส่วนบุคคลของท่าน
          เป็นระยะเวลาตราบเท่าที่จำเป็นต่อการประมวลผลตามวัตถุประสงค์ในนโยบายฉบับนี้เท่านั้น
          เว้นแต่มีความจำเป็นต้องเก็บข้อมูลส่วนบุคคลไว้ด้วยเหตุอื่นใด เช่น
          เพื่อปฎิบัติตามกฎหมายหรือการตรวจสอบกรณีการเกิดข้อพิพาท เรา
          อาจมีความจำเป็นต้องเก็บข้อมูลไว้เป็นระยะเวลาเกินกว่าที่ระบุ ทั้งนี้
          เมื่อพ้นระยะเวลาดังกล่าวเราจะทำให้ข้อมูลส่วนบุคคลของท่านไม่สามารถระบุตัวตนได้เพื่อการใช้ประโยชน์ด้านอื่น
          เช่น การวิเคราะห์ทางสถิติ การปรับปรุงประสิทธิภาพการทำงาน
          หรือประโยชน์สาธารณะที่สำคัญ
        </div>
        <div class="mb-3">
          <b>8. การรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล</b><br />
          เรามีมาตรการในการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคลของท่านอย่างเหมาะสม
          ทั้งในเชิงเทคนิคและการบริหารจัดการ เพื่อป้องกันมิให้ข้อมูลสูญหาย
          หรือมีการเข้าถึง ทำลาย ใช้ เปลี่ยนแปลง แก้ไข
          หรือเปิดเผยข้อมูลส่วนบุคคลโดยไม่ได้รับอนุญาต
          ซึ่งสอดคล้องกับนโยบายและแนวปฏิบัติด้านความมั่นคงปลอดภัยสารสนเทศ
          (Information Security Policy) ของเรา นอกจากนี้
          เราได้กำหนดให้มีนโยบายการคุ้มครองข้อมูลส่วนบุคคลขึ้น
          โดยประกาศให้ทราบกันโดยทั่วทั้งองค์กร
          พร้อมแนวทางปฏิบัติเพื่อให้เกิดความมั่นคงปลอดภัยในการเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคล โดยธำรงไว้ซึ่งความเป็นความลับ
          (Confidentiality) ความถูกต้องครบถ้วน (Integrity) และสภาพพร้อมใช้งาน
          (Availability) ของข้อมูลส่วนบุคคล
          โดยเราได้จัดให้มีการทบทวนนโยบายดังกล่าวรวมถึงประกาศนี้ในระยะเวลาตามที่เหมาะสม
        </div>
        <div class="mb-3">
          <b>9. การมีส่วนร่วมของเจ้าของข้อมูลส่วนบุคคล</b><br />
          เราอาจเปิดเผยข้อมูลส่วนบุคคลก็ต่อเมื่อได้รับคำร้องขอจากเจ้าของข้อมูลส่วนบุคคล
          ผู้สืบสิทธิ์ ทายาท ผู้แทนโดยชอบธรรม
          หรือผู้อนุบาลหรือผู้พิทักษ์ตามกฎหมาย โดยส่งคำร้องขอผ่าน <br />
          บริษัท สยามสแควร์ เทคโนโลยี (ประเทศไทย) จำกัด<br />
          - สถานที่ติดต่อ: 23/69-71 ซอยศูนย์วิจัย ถนนพระรามเก้า แขวงบางกะปิ
          เขตห้วยขวาง กรุงเทพมหานคร 10310<br />
          - ช่องทางการติดต่อ: <br />
          Email: dpo@siamsquared.com<br />
          Call Center : 09 2249 4999<br />
        </div>

        <div class="mb-3">
          ในกรณีที่เจ้าของข้อมูล ผู้สืบสิทธิ์ ทายาท ผู้แทนโดยชอบธรรม
          หรือผู้พิทักษ์ตามกฎหมายมีการคัดค้านการจัดเก็บ ความถูกต้อง
          หรือการกระทำใด ๆ เช่น การแจ้งดำเนินการปรับปรุงแก้ไขข้อมูลส่วนบุคคล
          เราจะดำเนินการบันทึกหลักฐานคำคัดค้านดังกล่าวไว้เป็นหลักฐานด้วย ทั้งนี้
          เราอาจปฏิเสธสิทธิตามวรรคสองได้ตามกรณีที่มีกฎหมายกำหนด
          หรือในกรณีที่ข้อมูลส่วนบุคคลของท่านถูกทำให้ไม่ปรากฏชื่อหรือสิ่งบอกลักษณะอันสามารถระบุตัวท่านได้
        </div>

        <div class="mb-3">
          <b>10. ความรับผิดชอบของบุคคลซึ่งประมวลผลข้อมูลส่วนบุคคล</b><br />
          เราได้กำหนดให้เจ้าหน้าที่เฉพาะผู้ที่มีอำนาจหน้าที่เกี่ยวข้องในการจัดเก็บรวบรวม
          ใช้
          และเปิดเผยข้อมูลส่วนบุคคลของกิจกรรมการประมวลผลนี้เท่านั้นที่จะสามารถเข้าถึงข้อมูลส่วนบุคคลของท่านได้
          โดยเราจะดำเนินการให้เจ้าหน้าที่ปฏิบัติตามประกาศนี้อย่างเคร่งครัด
        </div>

        <div class="mb-3">
          <b>11. การเปลี่ยนแปลงแก้ไขคำประกาศเกี่ยวกับความเป็นส่วนตัว</b><br />
          ในการปรับปรุงหรือเปลี่ยนแปลงประกาศนี้
          เราอาจพิจารณาแก้ไขเปลี่ยนแปลงตามที่เห็นสมควร
          และจะทำการแจ้งให้ท่านทราบผ่านช่องทางอีเมลเป็นหลัก
          หรือช่องทางอื่นที่ท่านสะดวกให้ไว้กับเรา
          โดยมีวันที่ของเวอร์ชันล่าสุดกำกับอยู่ตอนท้าย อย่างไรก็ดี
          เราขอแนะนำให้ท่านโปรดตรวจสอบเพื่อรับทราบประกาศฉบับใหม่อย่างสม่ำเสมอ
          โดยเฉพาะก่อนที่ท่านจะเปิดเผยข้อมูลส่วนบุคคลแก่เรา
          โดยในการเข้าใช้งานผลิตภัณฑ์หรือบริการภายใต้กิจกรรมการประมวลผลนี้ของท่าน
          ถือเป็นการรับทราบตามข้อตกลงในประกาศนี้<br />ทั้งนี้
          โปรดหยุดการใช้บริการหากท่านไม่เห็นด้วยกับข้อตกลงในประกาศฉบับนี้
          หากท่านยังคงใช้งานต่อไปภายหลังจากที่ประกาศนี้มีการแก้ไขและนำขึ้นประกาศในช่องทางข้างต้นแล้ว
          จะถือว่าท่านได้รับทราบการเปลี่ยนแปลงดังกล่าวแล้ว
        </div>
        <div class="mb-3">
          <b>12. การติดต่อสอบถาม</b><br />
          บริษัท สยามสแควร์ เทคโนโลยี (ประเทศไทย) จำกัด<br />
          23/69-71 ซอยศูนย์วิจัย ถนนพระรามเก้า แขวงบางกะปิ เขตห้วยขวาง
          กรุงเทพมหานคร 10310<br />
          Email: dpo@siamsquared.com<br />
          Call Center : 09 2249 4999
        </div>
        <div class="mb-5 text-center">ประกาศ ณ วันที่ 31 พฤษภาคม พ.ศ. 2565</div>
        <div class="mb-3 text-center">Update Date:  1 June 2022</div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountTabMenu from "@/views/PrivacyPolicy/Menu";

export default {
  components: { AccountTabMenu },
};
</script>
